<template>
  <div class="column-number-filter">
    <Poptip trigger="hover" v-model="show" placement="bottom" width="220">
      <i-button icon="ios-funnel" :class="value > 0 ? 'active' : 0">
        <icon class="ms-help" type="ios-arrow-down" />
      </i-button>
      <div class="column-number-filter-content" slot="content">
        <div class="ms-help label">
          Больше чем
        </div>
        <div class="column-number-filter-value">
          <input-number
            v-model="value"
            :min="0"
            :formatter="costsFormatter"
            :parser="costsParser"
            :disabled="tableLoading"
          />
          <i-button icon="md-trash" @click="clearFilter" />
        </div>
        <div class="column-number-filter-apply">
          <i-button :disabled="tableLoading" type="primary" @click="applyFilter" long>
            Применить
          </i-button>
        </div>
      </div>
    </Poptip>
  </div>
</template>

<script>
import { costsFormatter, costsParser } from '@/utils'

export default {
  props: ['type', 'field'],
  data () {
    return {
      value: this.$store.state.filters[this.type][this.field],
      show: false
    }
  },
  computed: {
    tableLoading () {
      return this.$store.state.experience.tableLoading
    }
  },
  methods: {
    applyFilter () {
      this.$store.commit('CHANGE_FILTER', {
        type: this.type,
        field: this.field,
        value: this.value
      })
      this.show = false
    },
    clearFilter () {
      this.$store.commit('CHANGE_FILTER', {
        type: this.type,
        field: this.field,
        value: 0
      })
      this.value = 0
      this.show = false
    },
    costsFormatter,
    costsParser
  }
}
</script>

<style lang="less">
.column-number-filter {
  display: flex;
  align-items: center;

  .ivu-btn {
    & > span {
      margin-left: 0;
    }

    .ivu-icon {
      font-size: 14px;
    }

    &.active {
      color: @primary-color;
    }
  }

  &-content {
    display: flex;
    flex-direction: column;
  }

  &-value {
    display: flex;
    align-items: center;

    .ivu-input-number {
      flex: 1;
    }

    .ivu-btn {
      margin-left: 8px;
    }
  }

  &-apply {
    margin-top: 16px;
  }
}

.dark {
  .column-number-filter .ivu-btn {
    background-color: rgba(@dt-dark-primary, 0.6);
  }
}

.light {
  .column-number-filter .ivu-btn {
    background-color: rgba(@lt-dark-primary, 0.1);
  }
}
</style>
